$(function () {
    setTimeout(function () {
        gRecuptchaRender();
    }, 100);

    function gRecuptchaRender(){
        if($("#g-recaptcha-container").length){
            if(!window.grecaptcha || !window.grecaptcha.render){
                setTimeout(function () {
                    gRecuptchaRender();
                }, 100);
            }
            else {
                window.grecaptcha.render( 'g-recaptcha-container', {
                    'sitekey' : '6LePaGcaAAAAALPTORkT5ROcQctp0S-hQxqfvd_X',
                    'size' : window.innerWidth < 400 ? 'compact' : 'normal',
                    'theme' : 'light'
                });
            }
        }
    }

    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    }
    window.addEventListener('resize', appHeight);
    appHeight();

    if(window.location.pathname.indexOf('register') !== -1){
        let now = new Date();
        now.setTime(now.getTime() + 6*30*24*60*60*1000);
        document.cookie = `timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}; Expires=${now.toUTCString()};`;
    }

    function inputHasChanged() {
        $("input.main-form__field").each( function (){
            if($( this ).val() !== ''){
                $(this).siblings('.main-form__field__title').toggleClass('to-top', true);
            }
        });
    };

    setTimeout(() => {inputHasChanged()}, 200);
    setTimeout(() => {inputHasChanged()}, 400);
    setTimeout(() => {inputHasChanged()}, 700);
    setTimeout(() => {inputHasChanged()}, 1000);
    setTimeout(() => {inputHasChanged()}, 1300);
    setTimeout(() => {inputHasChanged()}, 1900);
    setTimeout(() => {inputHasChanged()}, 2600);
    setTimeout(() => {inputHasChanged()}, 3700);
    setTimeout(() => {inputHasChanged()}, 5000);

    $(".sidebar-header__hamburger").click(function () {
        const sidebar = document.querySelector('#sidebar');
        sidebar.classList.toggle('collapsed');
    });
    if (window.location.pathname === '/setup' && !$("#sidebar").hasClass("new-account")) {
        $("#sidebar").addClass('disabled-sidebar');
    }
    $(".list-sidebar .item-wrapper").each(function() {
        if (window.location.pathname.includes($(this).find('a').attr('href'))) {
            $(this).addClass('item-wrapper_active');
        }
    });
    $(".list-sidebar .block-links .menu-item").each(function() {
        if (window.location.pathname.includes($(this).find('a').attr('href'))) {
            $(this).addClass('item-wrapper_active');
        }
    });

    window.addEventListener('load', function(event){
        const owid = window.outerWidth;
        const iwid = window.innerWidth;
        const mvp = document.getElementById('viewport');
        if(owid < 1280 && mvp) {
            if(window.location.href.indexOf('/setup') === -1){
                $('#body').toggleClass('force-desktop', true);
                mvp.setAttribute('content', 'width=1280, initial-scale=0, user-scalable=yes');
            }
        }
        if(owid >= 1280 && iwid < 1280 && mvp){
            $('#body').toggleClass('force-desktop', true);
            mvp.setAttribute('content', 'width=1280, initial-scale=0');
        }
    });

    $("#code").submit(function(e) {
        e.preventDefault(); // avoid to execute the actual submit of the form.
        var form = $(this);
        var url = "/verify";
        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
            success: function(data)
            {
               $('#code_input').removeClass('is-invalid');
               if (data == 'resend') {
                   $('#code_input').addClass('is-invalid');
                   $('.invalid-feedback strong').html('Code time is expired. <a class="resend" href="#">Click to send new code</a>');
               }
               else {
                   if (data == 'error') {
                       $('#code_input').addClass('is-invalid');
                       $('.invalid-feedback strong').html('The code you entered is incorrect. Try again.');
                   } else {
                       location.reload();
                   }
               }
            }
        });
    });

    $('.invalid-feedback strong').on('click', '.resend', function(e) {
        e.preventDefault();
        $('#resend-code').submit();
    });

});

